import script from "./DNTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DNTable.vue?vue&type=script&setup=true&lang=js"

import "./DNTable.vue?vue&type=style&index=0&id=076279d0&lang=scss&scoped=true"

import exportComponent from "/Users/sam/WebDev/Projects/debtnote/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076279d0"]])

export default __exports__